import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { ProveedorService } from 'src/app/services/proveedor.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { ModalSeleccionarProveedorComponent } from 'src/app/views/shared/modal-seleccionar-proveedor/modal-seleccionar-proveedor.component';

@Component({
  selector: 'app-cc-proveedor-pagos-cabecera',
  templateUrl: './cc-proveedor-pagos-cabecera.component.html',
  styleUrls: ['./cc-proveedor-pagos-cabecera.component.scss'],
  providers: [SecurityService, ValidadoresService]
})
export class CcProveedorPagosCabeceraComponent implements OnInit {

  @ViewChild(ModalSeleccionarProveedorComponent, { static: true }) modalSeleccionarProveedor: ModalSeleccionarProveedorComponent



  public formBus: FormGroup;
  public formProveedor: FormGroup;
  public rutProveedorSel;
  public nombreProveedorSel;
  public enabled:boolean=true;

  rutEmpresa: number;
  sucursalEmpresa:number;
  listaProveedores:any;
  proveedorSeleccionado: any = null
  headerData: any = {}

  @Output() eventoIniciaPago = new EventEmitter();
  @Output() onProveedorChange: EventEmitter<any> = new EventEmitter<any>()

  constructor(
    private accesolocalstorage: SecurityService,
    public validadores: ValidadoresService,
    public rutService: RutService,
    private proveedorDeudaService: ProveedorService,
    private toastService: ToastService,
    private formValidatorsService: FormValidatorsService
    ) { }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.createFormBuscaProveedor();
    this.createFormBusProveedor();
    this.formChangesSubscriptions();

  }

  deshabilita(){
      this.enabled=false;

  }


  iniciaProcesoPago(){
    if (!this.proveedorSeleccionado) {
      this.toastService.info('seleccione proveedor');
      return;
    }
    this.eventoIniciaPago.emit(this.proveedorSeleccionado.rutFormato);

  }

  createFormBuscaProveedor()
  {
    this.formProveedor = new FormGroup({
      rutProveedor: new FormControl('', [
        Validators.minLength(7),
        Validators.maxLength(13),
        Validators.required,
        this.validadores.ValidaFormatoRut,
      ]),
      nombreProveedor: new FormControl('')
    });
  }
  createFormBusProveedor(){
    this.formBus = new FormGroup({
      rutProveedor: new FormControl('')
    });
  }

  // seleccionaProveedor(prov:any){
  //   this.formBus.get('rutProveedor').setValue(this.validadores._enmascaraRut(prov.rut));
  //   this.nombreProveedorSel= prov.nombre;
  //   this.rutProveedorSel= prov.rut;
  //   this.modalSeleccionarProveedor.hide();

  // }

  private formChangesSubscriptions() {
    this.formBus.get("rutProveedor").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutProveedor: string) => {
        this.modalSeleccionarProveedor.searchByRut(rutProveedor)
        this.modalSeleccionarProveedor.clearLast();
      })
    }

    abrirModalSeleccionarProveedor() {
      this.modalSeleccionarProveedor.show()
    }

    onProveedorSeleccionado({ data, origen }) {
      this.proveedorSeleccionado = data
      this.proveedorSeleccionado.rutFormato = this.rutService.AgregarDV(this.proveedorSeleccionado.rut)
      this.formBus.get('rutProveedor').setValue(this.proveedorSeleccionado.rutFormato);
      if (data && data.sinDeudaCuentaCorriente) {
        this.toastService.info('proveedor sin deuda');
        return;
      }
      this.iniciaProcesoPago();
    }

    onProveedorNoEncontrado() {
      this.proveedorSeleccionado = null
      this.clearProveeData()
    }

    clearProveeData() {
      this.clearContent()
      this.onProveedorChange.emit(null)
    }

    clearContent(){
      this.headerData = {}
      // this.formValidatorsService.reset(this.formBus)
    }



  mascaraRut(evento) {
    this.validadores._mascaraRut(evento);
  }

  loadProveedoresConDeuda() {
    let rutNumero:number;
    rutNumero = this.rutService.QuitarDV(this.formProveedor.get('rutProveedor').value)


    this.proveedorDeudaService.getProveedorConDeuda(this.rutEmpresa, rutNumero, this.formProveedor.get('nombreProveedor').value, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      if (registros.count<0){
        this.toastService.warning("No se encontraron registros");
      }
      this.listaProveedores = registros

    })
  }

  limpiar(): void {
    this.enabled = true;
    this.proveedorSeleccionado = null;
    this.nombreProveedorSel = '';
    this.rutProveedorSel = '';
    this.headerData = {};
    this.formBus.reset();
    this.formProveedor.reset();
  }
}
